import { NgModule } from "@angular/core";
import { DropdownFormComponent } from './dropdown-form/dropdown-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DropdownDesignComponent } from './dropdown-design/dropdown-design.component';
import { DynamicDropdownComponent } from './dynamic-dropdown.component';
import { MaterialModule } from '../../material.module';
import { DropdownResultComponent } from './dropdown-result/dropdown-result.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { KendoModule } from '../kendo.module';

@NgModule({
    declarations: [
        DynamicDropdownComponent,
        DropdownDesignComponent,
        DropdownFormComponent,
        DropdownResultComponent
    ], 
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        NgxMatSelectSearchModule,
        ScrollingModule
    ],
    exports: [
        DropdownFormComponent
    ],
    entryComponents: [
        DynamicDropdownComponent
    ]
})
export class DropdownModule {}